import { useI18n } from "@/context/I18nContext";

export function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <div
      className={`inline-flex items-center rounded-md border border-stone-200 bg-white overflow-hidden text-xs font-semibold ${className}`}
      data-testid="lang-toggle"
    >
      <button
        onClick={() => setLang("en")}
        className={`px-3 py-1.5 transition-colors ${lang === "en" ? "bg-emerald-900 text-white" : "text-stone-600 hover:bg-stone-100"}`}
        data-testid="lang-en"
      >
        EN
      </button>
      <button
        onClick={() => setLang("hi")}
        className={`px-3 py-1.5 transition-colors ${lang === "hi" ? "bg-emerald-900 text-white" : "text-stone-600 hover:bg-stone-100"}`}
        data-testid="lang-hi"
      >
        हिं
      </button>
    </div>
  );
}
